/**
 * A short quick quote block inside informational content: after the first
 * paragraph of a blog post ($slug.tsx) and after the answer on an FAQ page
 * (faq.$slug.tsx).
 *
 * The line makes no price claim. The button label is the one on the home
 * page hero. Wording changes need Brian's approval before merge.
 *
 * The link is relative, so the site's link decorator adds the stored UTM and
 * click ID parameters, and the Zaraz trigger on a[href*="quick-quote"] sends
 * click_to_qq1.
 */
export function InlineQuoteCta() {
  return (
    <aside
      data-cta-location="inline_blog"
      aria-label="Get a quick quote"
      className="my-8 border-l-4 border-primary bg-muted px-5 py-5"
    >
      <p className="text-base font-semibold leading-snug text-foreground">
        See what your hair transplant would cost
      </p>
      <a
        href="/quick-quote-part-1/"
        className="mt-4 inline-block bg-primary px-6 py-3 text-sm font-bold tracking-wider text-primary-foreground no-underline transition hover:bg-primary/90"
      >
        Get a Quick Quote
      </a>
    </aside>
  );
}
